module.exports = __webpack_public_path__ + "media/excellusbcbs-app-page@md-6e3e8a267705ee8c10eca413b31d17c1.jpg";